import { UPDATE_FACES_VALUES, UPDATE_FACES_VALUES_SUCCESS, UPDATE_FACES_VALUES_ERROR } from './actionTypes';

const initialState = {
  errorUpdateFacesValues: '',
  loadingUpdateFacesValues: false,
  successUpdateFacesValues: '',
};

const updateFacesValues = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FACES_VALUES:
      state = {
        ...state,
        loadingUpdateFacesValues: true,
      };
      break;
    case UPDATE_FACES_VALUES_SUCCESS:
      state = {
        ...state,
        loadingUpdateFacesValues: false,
        successUpdateFacesValues: action.payload.message,
      };
      break;
    case UPDATE_FACES_VALUES_ERROR:
      state = { ...state, errorUpdateFacesValues: action.payload, loadingUpdateFacesValues: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateFacesValues;
